import React from 'react';
import PropTypes from 'prop-types';

const ReferralSection = ({ referralLink, copySuccess, onCopyLink }) => (
  <div className="mb-8 bg-[#DEF0DE] rounded-xl p-4 md:p-6 overflow-hidden" data-testid="ta-referral-section">
    <h2 className="text-[20px] md:text-[24px] font-bold leading-[26px] md:leading-[31px] text-[#1C2938] mb-4"
      style={{ fontFamily: 'Poppins, sans-serif' }}>
      Share with your client!
    </h2>

    <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-3 min-w-0">
      <div className="flex items-center gap-2 min-w-0 overflow-hidden">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="flex-shrink-0">
          <rect x="6" y="2" width="10" height="12" rx="1.5" stroke="#252525" strokeWidth="1.5"/>
          <path d="M4 6v10a1.5 1.5 0 001.5 1.5H14" stroke="#252525" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <span className="text-[14px] md:text-[16px] font-normal text-black break-all"
          data-testid="ta-referral-link"
          style={{ fontFamily: 'Poppins, sans-serif' }}>
          {referralLink}
        </span>
      </div>
      <button
        type="button"
        onClick={onCopyLink}
        data-testid="ta-copy-link-button"
        className="text-[14px] md:text-[16px] font-semibold text-[#252525] underline bg-transparent
          border-none cursor-pointer self-start md:ml-2"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        {copySuccess ? 'Copied!' : 'Copy link'}
      </button>
    </div>
  </div>
);

ReferralSection.propTypes = {
  referralLink: PropTypes.string.isRequired,
  copySuccess: PropTypes.bool.isRequired,
  onCopyLink: PropTypes.func.isRequired
};

export default ReferralSection;
